import { apiRoutes } from "./apiRoutes";
import { fetchJson } from "./fetchJson";




export const sendEvent = async (type: string, action: string, data: any) => {
    const resp = await fetchJson(`${apiRoutes.sendEvent}/${type}/${action}`, { method: 'POST', mode: 'cors', body: JSON.stringify(data) })
    console.log(resp)
    return resp;
}

